import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withCmsForm from 'modules/common/hoc/withCmsForm';
import * as actions from '../action';
import * as c from '../constant';

const CMS_TYPE = 'COLORS';

const fields = [
  'primary_color',
  'primary_color_light',
  'secondary_color',
  'warning_color',
  'danger_color',
  'muted_color',
  'muted_color_secondary',
  'glow_color',
  'light_color',
];

function Colors({
  getList,
  createInput,
  item,
  setFormData,
  createHidden,
  create,
  update,
  formData,
}) {
  useEffect(() => {
    getList({ type: CMS_TYPE });
  }, []);

  useEffect(() => {
    setFormData({
      ...JSON.parse(_.get(item, 'attributes.body') || '{}'),
      id: _.get(item, 'id'),
    });
  }, [item]);

  const handleOnSubmit = (e) => {
    e.preventDefault();

    if (_.get(formData, 'id')) {
      return update(_.get(formData, 'id'), {
        type: CMS_TYPE,
        body: JSON.stringify(_.pick(formData, fields)),
      });
    }

    return create({
      type: CMS_TYPE,
      body: JSON.stringify(_.pick(formData, fields)),
    });
  };

  return (
    <div>
      <form onSubmit={handleOnSubmit}>
        {createHidden({ key: 'id' }, { placeholder: '' })}
        <div className="row">
          <div className="col-12 form-group group-cms-color">
            {createInput(
              { key: 'primary_color', label: 'Primary Color:' },
              { required: true, type: 'color' },
              'input-cms-color'
            )}
          </div>
          <div className="col-12 form-group group-cms-color">
            {createInput(
              { key: 'primary_color_light', label: 'Primary Color Light:' },
              { required: true, type: 'color' },
              'input-cms-color'
            )}
          </div>
          <div className="col-12 form-group">
            {createInput(
              { key: 'secondary_color', label: 'Secondary Color:' },
              { required: true, type: 'color' },
              'input-cms-color'
            )}
          </div>
          <div className="col-12 form-group">
            {createInput(
              { key: 'warning_color', label: 'Warning Color:' },
              { required: true, type: 'color' },
              'input-cms-color'
            )}
          </div>
          <div className="col-12 form-group">
            {createInput(
              { key: 'danger_color', label: 'Danger Color:' },
              { required: true, placeholder: '', type: 'color' },
              'input-cms-color'
            )}
          </div>
          <div className="col-12 form-group">
            {createInput(
              { key: 'muted_color', label: 'Muted Color:' },
              { required: true, placeholder: '', type: 'color' },
              'input-cms-color'
            )}
          </div>
          <div className="col-12 form-group">
            {createInput(
              { key: 'muted_color_secondary', label: 'Muted Secondary Color:' },
              { required: true, placeholder: '', type: 'color' },
              'input-cms-color'
            )}
          </div>
          <div className="col-12 form-group">
            {createInput(
              { key: 'glow_color', label: 'Glow Color:' },
              { required: true, placeholder: '', type: 'color' },
              'input-cms-color'
            )}
          </div>
          <div className="col-12 form-group">
            {createInput(
              { key: 'light_color', label: 'Light Color:' },
              { required: true, placeholder: '', type: 'color' },
              'input-cms-color'
            )}
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            // disabled={creating}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              {/* {creating ? <i className="fa fa-spin fa-spinner" /> : `Submit`} */}
              Submit
            </span>
          </button>
        </div>
      </form>
    </div>
  );
}

Colors.propTypes = {
  getList: PropTypes.instanceOf(Function).isRequired,
  createInput: PropTypes.instanceOf(Function).isRequired,
  createHidden: PropTypes.instanceOf(Function).isRequired,
  item: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  create: PropTypes.instanceOf(Function).isRequired,
  update: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  item: (_.get(api, `${c.GET_SETTINGS}.list`) || [])[0] || {},
});

const enhance = _.flowRight([
  withCmsForm,
  withRouter,
  connect(mapStateToProps, actions),
]);

export default enhance(Colors);
